import React, {useContext} from 'react';
import { AiOutlinePushpin } from "react-icons/ai";
import { LanguageContext } from "../languages/LanguageContext";
import { HiArrowLongRight } from "react-icons/hi2";
import { Link } from "react-router-dom";

const Support = () => {
    const { language, translations } = useContext(LanguageContext);
    return (
        <div className='support-container flex wrap max-w gap-2 ai-c' id='support'>
            <div className='support-image'>
                <img src='/images/landing/landing-image-3.jpg' alt=''/>
            </div>
            <div className='support-content'>
                <h2>{translations[language]["help"]}</h2>
                <div className='list flex col gap-sm'>
                    <div className='list-item'>
                        <span className='point'><AiOutlinePushpin className='icon' /></span>
                        {translations[language]["careerPlanning"]}
                    </div>
                    <div className='list-item'>
                        <span className='point'><AiOutlinePushpin className='icon' /></span>
                        {translations[language]["participation"]}
                    </div>
                    <div className='list-item'>
                        <span className='point'><AiOutlinePushpin className='icon' /></span>
                        {translations[language]["foreignInternships"]}
                    </div>
                    <div className='list-item'>
                        <span className='point'><AiOutlinePushpin className='icon' /></span>
                        {translations[language]["development"]}
                    </div>
                    <div className='list-item'>
                        <span className='point'><AiOutlinePushpin className='icon' /></span>
                        {translations[language]["research"]}
                    </div>
                    <div className='list-item'>
                        <span className='point'><AiOutlinePushpin className='icon' /></span>
                        {translations[language]["support"]}
                    </div>
                </div>
                <Link to='/about'>
                    <button>
                        {translations[language]["moreAboutUs"]}
                        <HiArrowLongRight className='icon-btn'/>
                    </button>
                </Link>
            </div>
        </div>
    );
};

export default Support;